import { SWRFetcher } from '@commenda/utils';
import useSWR from 'swr';

import type {
  IManagementReportDatasetFilters,
  IManagementReportDatasetResponse,
} from './types';

export function useManagementReportDataset(
  corporationId: number | null,
  filters: IManagementReportDatasetFilters | null
) {
  const params = new URLSearchParams({
    corporationId: String(corporationId),
    periodStart: filters?.periodStart ?? '',
    periodEnd: filters?.periodEnd ?? '',
  });

  const { data, error, isLoading } = useSWR<IManagementReportDatasetResponse>(
    corporationId && filters
      ? `management-reports/dataset?${params.toString()}`
      : null,
    SWRFetcher({ method: 'GET' })
  );

  return {
    dataset: data?.dataset ?? null,
    isLoading,
    error,
  };
}
